export type Accessibility = 'accessibleBathroom' | 'elevator' | 'ramp' | 'disabilityAccess';

type AccessibilityItems = {
  [key in Accessibility]: boolean | null;
};

export interface AccessibilityDto extends AccessibilityItems {
  id: string;
  accessibilityNotes: string | null;
}

export const accessibilityMap = new Map<Accessibility, string>([
  ['accessibleBathroom', 'Accessible bathroom'],
  ['elevator', 'Elevator'],
  ['ramp', 'Ramp'],
  ['disabilityAccess', 'Disability access'],
]);
